import dayjs from 'dayjs';
import cn from 'classnames';
// Types
import { GetVideoEditRequestsForStore_getVideoEditRequestsForStore_entities } from 'api/mediaPost/types/GetVideoEditRequestsForStore';
// Ui3
import Button from 'ui3/Button/Button';
// Styles
import styles from './VideoRequestCard.module.scss';

type VideoRequestCardProps = {
  index: number;
  videoRequest: GetVideoEditRequestsForStore_getVideoEditRequestsForStore_entities;
  setReviewModalVisibility: (
    videoRequest: GetVideoEditRequestsForStore_getVideoEditRequestsForStore_entities
  ) => void;
  compact?: boolean;
};

const VideoRequestCard = ({
  index,
  videoRequest,
  setReviewModalVisibility,
  compact = false,
}: VideoRequestCardProps) => {
  const { createdAt, editedVideos } = videoRequest;

  const displayDate = dayjs(createdAt).format('MM.DD.YYYY.');

  const handleReviewModalOpen = () => {
    setReviewModalVisibility(videoRequest);
  };

  return (
    <div className={cn(styles.root, { [styles.rootCompact]: compact })}>
      <div className={styles.infoWrapper}>
        <p className={cn(styles.title, styles.large)}>Video request #{index}</p>

        <div className={styles.dataSection}>
          <p className={styles.data}>
            Date:<span className={styles.dataValue}>{displayDate}</span>
          </p>
          <p className={styles.data}>
            Number of videos:
            <span className={styles.dataValue}>{editedVideos.length}</span>
          </p>
        </div>

        <div className={styles.buttonWrapper}>
          <Button
            size="medium"
            variant="secondary"
            onClick={handleReviewModalOpen}
            className={styles.reviewMediaPostButton}
          >
            Review
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VideoRequestCard;
